module.exports = __webpack_public_path__ + "static/img/hm_loop_card_04.7514b6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthMonitoring/hm_loop_card_04.png
// module id = 61M0
// module chunks = 1